module.exports = __webpack_public_path__ + "static/media/loanStatus.04e3247b.svg";